import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import { attributesNames } from '../../../../constants'
// import { Logger, LoggerTypes } from '../../../../utils'
import { AttributeToolsHeader } from '../../AttributeToolsHeader'
import { AttributeLocationDialogCreate } from '../dialogs'
import { AttributeLocationCard } from '../AttributeLocationCard'

export const AttributeLocationPanel = ({
  locations,
  currentProject,
  currentScenario,
  terms,
  openDialog,
  setOpenDialog,
  onSearch,
  onAdd,
  onUpdate,
  onImport,
  onDelete,
  onCreate
}) => {
  // Logger.trace(LoggerTypes.CONTAINER, 'AttributeLocationPanel.render()', {
  //   currentProject,
  //   currentScenario,
  //   locations,
  //   terms
  // })

  const TAB_PANEL_HEIGHT = `${$(window).height() - 330}px`

  return (
    <div className="AttributeLocationPanel">
      <AttributeToolsHeader
        currentProject={currentProject}
        currentScenario={currentScenario}
        attributeName={attributesNames.LOCATIONS}
        terms={terms}
        onSearch={onSearch}
        onAdd={onAdd}
        onImport={onImport}
      />
      <div className="attributes-list" style={{ overflow: 'hidden auto', marginTop: '53px', height: TAB_PANEL_HEIGHT }}>
        {locations &&
          locations.map((location, index) => (
            <AttributeLocationCard
              key={`location-${index}`}
              location={location}
              currentProject={currentProject}
              currentScenario={currentScenario}
              actionDispatchDelete={onDelete}
              actionDispatchUpdate={onUpdate}
            />
          ))}
      </div>
      {openDialog && (
        <AttributeLocationDialogCreate
          currentProject={currentProject}
          currentScenario={currentScenario}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          actionCreateDispatch={onCreate}
        />
      )}
    </div>
  )
}

AttributeLocationPanel.displayName = 'AttributeLocationPanel'

AttributeLocationPanel.propTypes = {
  locations: PropTypes.array.isRequired,
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  terms: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onCreate: PropTypes.func,
  onImport: PropTypes.func
}

AttributeLocationPanel.defaultProps = {
  locations: [],
  currentProject: null,
  currentScenario: null,
  terms: '',
  openDialog: false,
  setOpenDialog: () => {},
  onSearch: null,
  onAdd: null,
  onUpdate: null,
  onDelete: null,
  onCreate: null,
  onImport: null
}
